export default __webpack_public_path__ + "static/media/click3.2a61a5fa.ogg";